import { render, staticRenderFns } from "./ClientAdd.vue?vue&type=template&id=6e2c6d27&scoped=true"
import script from "./ClientAdd.vue?vue&type=script&lang=js"
export * from "./ClientAdd.vue?vue&type=script&lang=js"
import style0 from "./ClientAdd.vue?vue&type=style&index=0&id=6e2c6d27&prod&lang=css"
import style1 from "./ClientAdd.vue?vue&type=style&index=1&id=6e2c6d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c6d27",
  null
  
)

export default component.exports